import { render, staticRenderFns } from "./JCategorySelect.vue?vue&type=template&id=dd8a4e62"
import script from "./JCategorySelect.vue?vue&type=script&lang=js"
export * from "./JCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports